import * as React from 'react';

export function extractTextFromCommandLabel(label: string | React.ReactNode): string {
  if (typeof label === 'string') {
    return label;
  }

  const extract = (node: React.ReactNode): string => {
    if (typeof node === 'string') {
      return node;
    }

    if (typeof node === 'number' || typeof node === 'bigint') {
      return String(node);
    }

    if (Array.isArray(node)) {
      return node
        .map((child) => extract(child))
        .filter((part) => part.length > 0)
        .join(' ');
    }

    if (React.isValidElement<{ children?: React.ReactNode }>(node)) {
      const { children } = node.props;
      if (Array.isArray(children)) {
        return children
          .map((child) => extract(child))
          .filter((part) => part.length > 0)
          .join(' ');
      }

      return extract(children);
    }

    return '';
  };

  return extract(label).trim().replace(/\s+/g, ' ');
}
